import React, { useState, useEffect } from 'react'
import { MEDIUM } from '../constants'
import 'katex/dist/katex.min.css'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'

function TypeAnswerComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    handleSucAndFailFeedback,
    initial,
    isResetClick,
    isPageRefresh
  } = props
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Type,
    MinRange,
    MaxRange,
    Score,
    Background,
    Description,
    QuestionColorFill,
    QuestionFontSize,
    Opacity,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    SequenceHint,
    TypeAnswer,
    Priority,
    TextAlign
  } = mcData

  const [value, setValue] = useState('')
  const [validate, setValidate] = useState(false)
  const [onBlurCall, setOnBlurCall] = useState(true)

  useEffect(() => {
    if (initial) {
      setOnBlurCall(true)
    }
  }, [initial])

  useEffect(() => {
    if (isResetClick) {
      setOnBlurCall(true)
    }
  }, [isResetClick])

  useEffect(() => {
    if (isPageRefresh) {
      setOnBlurCall(true)
    }
  }, [isPageRefresh])

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlValue) {
          let defaultValueSelected = defaultValue.CtlValue
          setValue(defaultValueSelected)
          if (Type === 'exactMatch') {
            if (defaultValueSelected === TypeAnswer) {
              setValidate(true)
            } else {
              setValidate(false)
            }
          } else if (Type === 'range') {
            if (
              parseFloat(defaultValueSelected) >= MinRange &&
              parseFloat(defaultValueSelected) <= MaxRange
            ) {
              setValidate(true)
            } else {
              setValidate(false)
            }
          }
        }
      } else {
        setValue('')
      }
      setOnBlurCall(false)
    }
  }, [defaultValue, onBlurCall])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true)
    }
  }, [timerEnd])

  useEffect(() => {
    if (value) {
      if (Type === 'exactMatch') {
        if (value === TypeAnswer) {
          setValidate(true)
        } else {
          setValidate(false)
        }
      } else if (Type === 'range') {
        if (parseFloat(value) >= MinRange && parseFloat(value) <= MaxRange) {
          setValidate(true)
        } else {
          setValidate(false)
        }
      }
    }
  }, [value])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    if (Type === 'exactMatch') {
      if (value === TypeAnswer) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    } else if (Type === 'range') {
      if (parseFloat(value) >= MinRange && parseFloat(value) <= MaxRange) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }

  function successHandle() {
    if (Type === 'exactMatch') {
      if (value === TypeAnswer) {
        handleSuccessChange(true)
      } else {
        handleSuccessChange(false)
      }
    } else if (Type === 'range') {
      if (parseFloat(value) >= MinRange && parseFloat(value) <= MaxRange) {
        handleSuccessChange(true)
      } else {
        handleSuccessChange(false)
      }
    }
  }

  function validateAnswer() {
    let isCorrect = false
    if (Type === 'exactMatch') {
      if (value === TypeAnswer) {
        isCorrect = true
      } else {
        isCorrect = false
      }
    } else if (Type === 'range') {
      if (parseFloat(value) >= MinRange && parseFloat(value) <= MaxRange) {
        isCorrect = true
      } else {
        isCorrect = false
      }
    }
    return isCorrect
  }

  function validateCorrectAnswer(timerValue) {
    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (Type === 'exactMatch') {
          if (value === TypeAnswer) {
            onPriorityChange(Priority)
          }
        } else if (Type === 'range') {
          if (value >= MinRange && parseFloat(value) <= MaxRange) {
            onPriorityChange(Priority)
          }
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (Type === 'exactMatch') {
      if (value === TypeAnswer) {
        onValueChange(ControlID, value, Score, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        onValueChange(ControlID, value, 0, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    } else if (Type === 'range') {
      if (parseFloat(value) >= MinRange && parseFloat(value) <= MaxRange) {
        onValueChange(ControlID, value, Score, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        onValueChange(ControlID, value, 0, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
    >
      <div
        style={{
          width: '100%',
          height: '50%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            width: isEmbeded ? '90%' : '50%',
            alignSelf: 'center',
            borderColor: '#0bff31',
            borderStyle: 'none',
            display: 'flex'
          }}
        >
          <input
            className='Rectangle-2091'
            autoComplete='off'
            style={{
              width: '100%',
              height: '100%',
              alignSelf: 'center',
              borderColor:
                isPractice || completed === 1 || !isActive
                  ? value !== ''
                    ? validate
                      ? '#0bff31'
                      : 'red'
                    : 'black'
                  : 'black',
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
              textAlign: TextAlign
                ? TextAlign === 'left'
                  ? 'left'
                  : TextAlign === 'right'
                  ? 'right'
                  : 'center'
                : 'center'
            }}
            type={Type === 'range' ? 'number' : 'text'}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={(e) => {
              if (completed === 0) {
                successHandle(e.target.value)
                onAttemptChange(1)
                validateCorrectAnswer(false)
                setOnBlurCall(true)
              }
            }}
            readOnly={
              explanationClick
                ? true
                : completed === 1 || !isActive
                ? true
                : isPractice
                ? followTheFlow && isEmbeded
                  ? validateAnswer()
                    ? true
                    : false
                  : false
                : false
            }
            onKeyDown={(ev) => {
              if (ev.key === 'Enter') {
                ev.target.blur()
              } else if (ev.key === 'ArrowDown') {
                ev.target.blur()
              }
            }}
          />
        </div>
      </div>
      <div
        style={{
          width: '100%',
          height: '50%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        {isVerifyMode && (
          <p
            style={{
              textAlign: 'center',
              fontSize: MEDIUM,
              color: QuestionColorFill
            }}
          >
            {Type === 'range'
              ? 'The correct answer is "' + MinRange + ' - ' + MaxRange + '"'
              : 'The correct answer is "' + TypeAnswer + '"'}
          </p>
        )}
      </div>
    </div>
  )
}

export default TypeAnswerComponent
